<template>
    <div class="product__card">
        <div class="article__box">
            <div class="text">
                <div>
                    <span class="bold">Код:</span>
                    <span>{{ padLeadingZeros(product.id, 4) }}</span>
                </div>

                <div
                    class="svg__box"
                    v-if="!isFetchingFavourite"
                    :key="'product spinner'"
                >
                    <button
                        v-if="!product.favourite"
                        :key="'Product disliked'"
                        @click="addProductToFavorite"
                    >
                        <svg
                            width="17"
                            height="17"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                        >
                            <path
                                d="M12 21.593c-5.63-5.539-11-10.297-11-14.402 0-3.791 3.068-5.191 5.281-5.191 1.312 0 4.151.501 5.719 4.457 1.59-3.968 4.464-4.447 5.726-4.447 2.54 0 5.274 1.621 5.274 5.181 0 4.069-5.136 8.625-11 14.402m5.726-20.583c-2.203 0-4.446 1.042-5.726 3.238-1.285-2.206-3.522-3.248-5.719-3.248-3.183 0-6.281 2.187-6.281 6.191 0 4.661 5.571 9.429 12 15.809 6.43-6.38 12-11.148 12-15.809 0-4.011-3.095-6.181-6.274-6.181"
                                fill="#363f4d"
                            />
                        </svg>
                    </button>

                    <button v-else @click="removeProductFromFavorite">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17"
                            height="17"
                            viewBox="0 0 24 24"
                        >
                            <path
                                d="M12 4.248c-3.148-5.402-12-3.825-12 2.944 0 4.661 5.571 9.427 12 15.808 6.43-6.381 12-11.147 12-15.808 0-6.792-8.875-8.306-12-2.944z"
                                fill="#cc3a3a"
                            />
                        </svg>
                    </button>
                </div>

                <div class="svg__box" v-else>
                    <main-spinner :addition-style="'width:90%;height:90%;'">
                    </main-spinner>
                </div>
            </div>
        </div>

        <div class="img__box">
            <router-link
                :to="{
                    name: 'product',
                    params: {
                        id: product.id,
                        slug: product.slug || undefined
                    }
                }"
            >
                <img
                    v-lazy="
                        `https://pos.buum.uz/uploads/products/medium/${product.photo}`
                    "
                    alt="Product image"
                />
            </router-link>
        </div>

        <!-- <div class="rate__box">
            <div class="rate__block">
                <star-rating
                    class="star__rating "
                    :increment="0.5"
                    inactive-color="#219EBC"
                    :star-size="14"
                    :show-rating="false"
                    :rating="4.5"
                    :read-only="true"
                >
                </star-rating>
            </div>

            <div class="comment__box">
                <svg
                    class="svg__box"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M13.8776 4.55167H11.4286V2.75575C11.4286 1.58543 10.4764 0.633301 9.30612 0.633301H2.12245C0.952131 0.633301 0 1.58543 0 2.75575V6.02106C0 7.13645 0.864849 8.05364 1.95918 8.1373V11.4485L4.57143 8.83621V9.93946C4.57143 11.1098 5.52356 12.0619 6.69388 12.0619H10.7359L14.0408 15.3668V12.0557C15.1351 11.972 16 11.0548 16 9.93942V6.67412C16 5.5038 15.0479 4.55167 13.8776 4.55167ZM4.57143 6.67412V7.45084L2.93878 9.08349V7.16391H2.12245C1.49228 7.16391 0.979592 6.65123 0.979592 6.02106V2.75575C0.979592 2.12558 1.49228 1.61289 2.12245 1.61289H9.30612C9.93629 1.61289 10.449 2.12558 10.449 2.75575V4.55167H6.69388C5.52356 4.55167 4.57143 5.5038 4.57143 6.67412ZM15.0204 9.93942C15.0204 10.5696 14.5077 11.0823 13.8776 11.0823H13.0612V13.0019L11.1416 11.0823H6.69388C6.06371 11.0823 5.55102 10.5696 5.55102 9.93942V6.67412C5.55102 6.04395 6.06371 5.53126 6.69388 5.53126H13.8776C14.5077 5.53126 15.0204 6.04395 15.0204 6.67412V9.93942Z"
                        fill="#808080"
                    />
                    <path
                        d="M13.5501 6.8374H7.01953V7.81699H13.5501V6.8374Z"
                        fill="#808080"
                    />
                    <path
                        d="M13.5501 8.79639H7.01953V9.77598H13.5501V8.79639Z"
                        fill="#808080"
                    />
                </svg>
                <span>24 отзыва</span>
            </div>
        </div> -->

        <div class="name__box">
            <router-link
                :to="{
                    name: 'product',
                    params: {
                        id: product.id,
                        slug: product.slug || undefined
                    }
                }"
            >
                <span>{{ product.name }} {{ product.title }} </span>
            </router-link>
        </div>

        <div class="price__box" v-if="product.count > 0" :key="'priceBox'">
            <div class="heading">
                <span style="border:none" :class="{ error: maxCountError }">
                    В наличии: {{ product.count }} {{ typeProduct }}
                </span>
            </div>

            <div class="heading heading_second">
                <span> Цена за {{ typeProduct }}:</span>
            </div>

            <div class="amount">
                <span class="new__price">
                    {{ updatePriceFormat(product.price) }} сум
                </span>

                <div class="new__price__kvm">
<!--                    <span v-if="product.type_kv_m == 1 && selected>0">-->
<!--                        {{selected}} {{ typeProduct }} = {{ product.type == 16 ? Math.round(selected / Number(product.kv_m)*100)/100 : Math.round(selected * Number(product.kv_m) * 100 ) / 100 }}-->
<!--                        {{ product.type == 16 ? "шт." : "кв.м." }}</span>-->
                    <span v-if="product.type_kv_m != '0'">
                        {{ selected>0 ? selected : 1 }} {{ typeProduct }} = {{ selected>0 ? (Math.round(selected * Number(product.kv_m)*100)/100 ) : product.kv_m }}
                        {{ product.type_kv_m }}</span>
                </div>
<!--                              <span-->
                    <!--                    class="old__price"-->
                    <!--                    v-if="!!product.overall[0].oldPrice"-->
                    <!--                    :key="'oldPrice'"-->
                    <!--                >-->
                    <!--                    {{ updatePriceFormat(product.overall[0].oldPrice) }}-->
                    <!--                    сум</span-->
                    <!--                >-->

                <!-- <span class="old__price" v-else> 000 000 сум</span> -->
            </div>
        </div>

        <div class="price__box d-flex flex-column  justify-content-end" v-else>
            <div class="heading mb-2">
                <span style="border:none; color: #cc3a3a;">
                    Нет в наличии!</span
                >
            </div>
        </div>

        <div
            class="check__out__box"
            v-if="
                (selected === 0 && !isFetchingShopCart) ||
                    (!selected && !isFetchingShopCart)
            "
            :key="'check__out__box' + product.id"
        >
            <div class="check__out__button">
                <button
                    :disabled="!product.count"
                    @click="incrementProductCount"
                >
                    В корзину
                </button>
            </div>
        </div>

        <div
            class="count__toggle"
            v-if="selected > 0 && !isFetchingShopCart"
            :key="'shop cart count'"
        >
            <div class="count">
                <button class="minus" @click="decrementProductCount">
                    -
                </button>

                <input
                    type="number"
                    size="4"
                    placeholder="0"
                    v-model="selected"
                    :class="{ error: maxCountError }"
                    @keyup="1"
                />

                <button class="plus" @click="incrementProductCount">
                    +
                </button>
            </div>
        </div>

        <main-spinner
            v-if="isFetchingShopCart"
            :key="'product spinner'"
            :addition-style="'width:36px;height:36px;'"
        >
        </main-spinner>
    </div>
</template>

<script>
import StarRating from "vue-star-rating";
import MainSpinner from "../UI/MainSpinner.vue";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
    components: {
        StarRating,
        MainSpinner
    },

    props: {
        product: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            selected: 0,
            oldSelected: 0,
            maxCount: Number(this.product.count),
            timerIdForFetchingChanges: {},
            timerIdForChangeShopCartSellersLocally: 0,
            isFetchingFirstProductDetails: true,

            productCopy: {
                sortedSellers: [],
                selectedSellers: []
            },

            maxCountError: false,

            isLoggedin: false,

            typeProduct: "",

            isFetchingShopCart: false,
            isFetchingFavourite: false,

            mainFunctionTimerId: {}
        };
    },

    watch: {
        selected(newValue, oldValue) {
            if (newValue >= this.maxCount) {
                this.maxCountError = true;
            } else {
                this.maxCountError = false;
            }

            if (newValue > this.maxCount) {
                this.selected = this.maxCount;
            } else {
                // this will trigger when render happens first and don't send request
                if (oldValue !== 0) this.changeShopCartMainTrigger();
            }
        }
    },

    computed: {
        ...mapGetters(["shopcardProduct", "shopcardPackage", "getAllFavourite", "getProductTypeCodes"])
    },

    methods: {
        ...mapActions(["addToFavourite", "trashFromFavourite"]),

        ...mapMutations([
            "updateProductCountOnShopCardPackage",
            "removeProductPackageFromShopCard",
            "removeProductFromShopCard",
            "addProductToShopCard",
            "addPackageToShopCard",
            "addFavouriteProduct",
            "removeFavouriteProduct"
        ]),

        incrementProductCount() {
            if (this.maxCount > this.selected) {
                this.selected++;
                this.changeShopCartMainTrigger();
            } else {
                this.maxCountError = true;
            }
            this.ecommerceAddProduct();
        },

        decrementProductCount() {
            this.selected--;
            this.changeShopCartMainTrigger();
            this.maxCountError = false;
            this.ecommerceRemoveProduct();
        },

        async changeShopCartMainTrigger() {
            clearTimeout(this.mainFunctionTimerId);
            this.mainFunctionTimerId = setTimeout(() => {
                this.changeShopCartMainFunc();
            }, 500);
        },

        async changeShopCartMainFunc() {
            if (this.isLoggedin) {
                clearTimeout(this.timerIdForFetchingChanges);
                this.timerIdForFetchingChanges = setTimeout(() => {
                    this.changeShopCartCountWhenCountUpdated();
                }, 500);
            }

            if (!this.isLoggedin) {
                if (this.isFetchingFirstProductDetails) {
                    this.isFetchingShopCart = true;
                    const product = await this.fetchProductDetails();
                    this.findCheeapestSellerAndSaveToSortedSellers(product);
                    this.updateSelectedSellersOnMounted();
                    this.isFetchingShopCart = false;
                    this.isFetchingFirstProductDetails = false;
                }

                clearTimeout(this.timerIdForChangeShopCartSellersLocally);
                this.timerIdForChangeShopCartSellersLocally = setTimeout(() => {
                    this.updateValueOnSellersWhenChangingCountEnded();
                    this.updateAllSelectedSellersCountsLocally();
                    this.deleteProductsViaPackageWhenItCountZero();
                    if (this.selected > 0)
                        this.showNotification(
                            _,
                            "Корзина",
                            "Продукт успешно добавлён в корзину"
                        );
                    else
                        this.showNotification(
                            _,
                            "Корзина",
                            "Продукт успешно удалён из корзины"
                        );
                }, 500);
            }
        },

        async changeShopCartCountWhenCountUpdated() {
            this.isFetchingShopCart = true;
            const response = await this.fetchShopCartChange();

            if (response.data.status) {
                this.oldSelected = this.selected;
                this.updateStoreAfterFetch(response.data.result.product);
                if (this.selected > 0)
                    this.showNotification(
                        _,
                        "Корзина",
                        "Продукт успешно добавлён в корзину"
                    );
                else
                    this.showNotification(
                        _,
                        "Корзина",
                        "Продукт успешно удалён из корзины"
                    );
            }
            if (!response.data.status) {
                this.selected = this.oldSelected;
                this.showNotification(
                    "error",
                    "Корзина",
                    "Что-то пошло не так, повторите попитку пожалуйста!"
                );
            }

            this.isFetchingShopCart = false;
        },

        async fetchShopCartChange() {
            return await axios
                .get("/sanctum/csrf-cookie")
                .then(response => {
                    return axios
                        .post("/api/shopcart2/change", {
                            product_id: this.product.id,
                            count: this.selected
                        })
                        .then(response => response);
                })
                .catch(error => {
                    this.selected = this.oldSelected;
                    return false;
                });
        },

        updateStoreAfterFetch(products) {
            const productId = this.product.id;
            const productCopy = products.find(
                elem => elem.product_id === Number(productId)
            );
            const productOnStore = this.shopcardProduct(productId);

            if (!!productCopy) {
                const product = {
                    id: productCopy.product_id,
                    name: productCopy.name,
                    title: this.product.title,
                    photo: productCopy.photo,
                    weight: this.product.massa,
                    type: this.product.type,
                    packages: {}
                };
                this.addProductToShopCard(product);

                productCopy.seller.forEach(seller => {
                    const pack = {
                        id: seller.pc_id,
                        name: seller.pc_name,
                        count: seller.pc_count,
                        price: seller.pc_sum
                    };
                    this.addPackageToShopCard({ product, pack });
                });
            }

            if (!productCopy && !!productOnStore) {
                this.removeProductFromShopCard(this.product.id);
            }
        },

        async fetchProductDetails(attemptCount = 1) {
            return await axios
                .get("/api/product2/" + this.product.id)
                .then(response => {
                    if (response.data.status) {
                        return response.data.result;
                    }

                    if (!response.data.status && attemptCount < 3) {
                        return this.fetchProductDetails(++attemptCount);
                    }
                })
                .catch(error => false);
        },

        findCheeapestSellerAndSaveToSortedSellers(product) {
            let arrivals = [];
            if (typeof product?.arrivals === "object")
                arrivals = this.convertArrivalsToArrayIfItIsObject(
                    product?.arrivals
                );
            else arrivals = product?.arrivals;
            if (!!arrivals) {
                const sortedSellersByPrice = arrivals.sort((a, b) => {
                    return a.discount_price - b.discount_price;
                });
                this.productCopy.sortedSellers = [...sortedSellersByPrice];
            }
        },

        convertArrivalsToArrayIfItIsObject(arrivals) {
            const newArrivals = [];
            Object.keys(arrivals).forEach(key => {
                newArrivals.push(arrivals[key]);
            });
            return [...newArrivals];
        },

        updateSelectedSellersOnMounted() {
            const productId = this.product.id;
            this.productCopy.sortedSellers.forEach((elem, index) => {
                const packId = elem.id;
                const pack = this.shopcardPackage(productId, packId);
                if (!!pack) {
                    this.productCopy.selectedSellers[index] = { ...elem };
                    this.productCopy.selectedSellers[index].count = pack.count;
                }
            });
        },

        updateValueOnSellersWhenChangingCountEnded() {
            const oldCount = this.oldSelected;
            const newCount = this.selected;

            if (newCount < oldCount) {
                const difference = oldCount - newCount;
                const leng = this.productCopy.selectedSellers.length - 1;
                this.updateValueOnSellersWhenCountDecreased(
                    difference,
                    leng,
                    0
                );
            }

            if (newCount > oldCount) {
                const difference = newCount - oldCount;
                const leng = this.productCopy.sortedSellers.length - 1;
                this.updateValueOnSellersWhenCountIncreased(
                    difference,
                    0,
                    leng
                );
            }

            this.oldSelected = newCount;
        },

        updateValueOnSellersWhenCountDecreased(
            differenceBetweenOldAndNewValue,
            defaultIndex,
            end
        ) {
            const difference = Number(differenceBetweenOldAndNewValue);

            if (difference > 0 && defaultIndex >= end) {
                if (
                    difference >
                    Number(this.productCopy.selectedSellers[defaultIndex].count)
                ) {
                    const newDifference =
                        difference -
                        Number(
                            this.productCopy.selectedSellers[defaultIndex].count
                        );
                    this.productCopy.selectedSellers[defaultIndex].count = 0;

                    return this.updateValueOnSellersWhenCountDecreased(
                        newDifference,
                        defaultIndex - 1,
                        end
                    );
                }

                if (
                    difference <=
                    Number(this.productCopy.selectedSellers[defaultIndex].count)
                ) {
                    const newDifference =
                        Number(
                            this.productCopy.selectedSellers[defaultIndex].count
                        ) - difference;
                    this.productCopy.selectedSellers[
                        defaultIndex
                    ].count = newDifference;
                    return this.productCopy.selectedSellers;
                }
            } else {
                return this.productCopy.selectedSellers;
            }
        },

        updateValueOnSellersWhenCountIncreased(
            differenceBetweenOldAndNewValue,
            defaultIndex,
            end
        ) {
            const difference = Number(differenceBetweenOldAndNewValue);

            if (difference > 0 && defaultIndex <= end) {
                const obj = { ...this.productCopy.sortedSellers[defaultIndex] };
                const deafaultSelectedSeller = this.productCopy.selectedSellers[
                    defaultIndex
                ];

                if (!deafaultSelectedSeller) {
                    this.productCopy.selectedSellers[defaultIndex] = { ...obj };
                    if (difference > obj.count) {
                        const newDifference = difference - Number(obj.count);

                        return this.updateValueOnSellersWhenCountIncreased(
                            newDifference,
                            defaultIndex + 1,
                            end
                        );
                    } else {
                        this.productCopy.selectedSellers[
                            defaultIndex
                        ].count = difference;
                        return this.productCopy.selectedSellers;
                    }
                }

                if (!!deafaultSelectedSeller) {
                    const newChangedValue =
                        this.productCopy.selectedSellers[defaultIndex].count +
                        difference;

                    if (newChangedValue > obj.count) {
                        this.productCopy.selectedSellers[defaultIndex].count =
                            obj.count;
                        const newDifference =
                            newChangedValue - Number(obj.count);
                        return this.updateValueOnSellersWhenCountIncreased(
                            newDifference,
                            defaultIndex + 1,
                            end
                        );
                    } else {
                        this.productCopy.selectedSellers[
                            defaultIndex
                        ].count = newChangedValue;
                        return this.productCopy.selectedSellers;
                    }
                }
            } else {
                return this.productCopy.selectedSellers;
            }
        },

        updateAllSelectedSellersCountsLocally() {
            this.productCopy.selectedSellers.forEach(elem => {
                this.updateStoreValuesAfterChanges(elem);
            });
        },

        updateStoreValuesAfterChanges(elem) {
            const productId = this.product.id;
            const product = {
                id: this.product.id,
                name: this.product.name,
                title: this.product.title,
                photo: this.product.photo,
                weight: this.product.massa,
                type: this.product.type,
                packages: {}
            };

            const packId = elem.id;
            const countPackage = Number(elem.count);

            const pack = {
                id: elem.id,
                name: elem.company.name,
                count: elem.count,
                price: elem.discount_price
            };

            const isHasProduct = this.shopcardProduct(productId);

            if (!isHasProduct && countPackage >= 0) {
                this.addProductToShopCard(product);
                this.addPackageToShopCard({ product, pack });

                this.updateProductCountOnShopCardPackage({
                    productId,
                    packId,
                    countPackage
                });
            }

            if (!!isHasProduct && countPackage >= 0) {
                const isHasPackage = this.shopcardPackage(productId, packId);

                if (!!isHasPackage) {
                    this.updateProductCountOnShopCardPackage({
                        productId,
                        packId,
                        countPackage
                    });
                }

                if (!isHasPackage && countPackage > 0) {
                    this.addPackageToShopCard({ product, pack });
                    this.updateProductCountOnShopCardPackage({
                        productId,
                        packId,
                        countPackage
                    });
                }
            }
        },

        deleteProductsViaPackageWhenItCountZero() {
            const productId = this.product.id;
            const product = this.shopcardProduct(productId);
            let productCount = 0;

            if (!!product) {
                Object.keys(product.packages).forEach(key => {
                    productCount += product.packages[key].count;

                    if (product.packages[key].count === 0) {
                        const packId = product.packages[key].id;
                        this.removeProductPackageFromShopCard({
                            productId,
                            packId
                        });
                    }
                });

                if (productCount === 0) {
                    this.removeProductFromShopCard(productId);
                }
            }
        },

        updateProductSelectedCountLocallyWhenUnLogin() {
            const productId = this.product.id;
            const product = this.shopcardProduct(productId);
            let productCount = 0;

            if (!!product) {
                Object.keys(product.packages).forEach(key => {
                    productCount += product.packages[key].count;
                });

                this.selected = this.oldSelected = productCount;
            }
        },

        // pad leading zeros
        padLeadingZeros(num, size) {
            let s = num + "";
            while (s.length < size) s = "0" + s;
            return s;
        },

        // this function help us to define truth inform about products via different product props property
        generateProductData() {
            const weight = !!this.product.massa
                ? this.product.massa
                : this.product.weight;

            const productList = [
                {
                    product_id: Number(this.product.id),
                    name: this.product.name,
                    photo: this.product.photo,
                    weight: Number(weight)
                }
            ];
            return productList;
        },

        async addProductToFavorite() {
            const productList = this.generateProductData();
            if (!!this.isLoggedin) {
                this.isFetchingFavourite = true;
                const response = await this.addToFavourite(productList);
                if (!!response.data.status) {
                    this.product.favourite = true;
                    this.showNotification(
                        _,
                        "Избранные товары",
                        "Продукт успешно добавлён в список избранные"
                    );
                } else
                    this.showNotification(
                        "error",
                        "Избранные товары",
                        "Что-то пошло не так, повторите попитку пожалуйста!"
                    );
                this.isFetchingFavourite = false;
            } else {
                const product = _.cloneDeep(this.product);
                this.product.favourite = true;
                product.favourite = true;
                this.addFavouriteProduct(product);
                this.showNotification(
                    _,
                    "Избранные товары",
                    "Продукт успешно добавлён в список избранные"
                );
            }
        },

        async removeProductFromFavorite() {
            const productList = this.generateProductData();
            if (!!this.isLoggedin) {
                this.isFetchingFavourite = true;
                const response = await this.trashFromFavourite(productList);
                if (!!response.data.status) {
                    this.product.favourite = false;
                    this.showNotification(
                        _,
                        "Избранные товары",
                        "Продукт успешно удалён из списка избранные"
                    );
                } else
                    this.showNotification(
                        "error",
                        "Избранные товары",
                        "Что-то пошло не так, повторите попитку пожалуйста!"
                    );
                this.isFetchingFavourite = false;
            } else {
                const product = _.cloneDeep(this.product);
                product.favourite = false;
                this.product.favourite = false;
                this.removeFavouriteProduct(product);
                this.showNotification(
                    _,
                    "Избранные товары",
                    "Продукт успешно удалён из списка избранные"
                );
            }
        },

        checkForProductIsItLikedLocally() {
            const isLiked = this.getAllFavourite.find(
                product => Number(product.id) === Number(this.product.id)
            );
            if (!!isLiked) this.product.favourite = true;
        },

        updateSelectedOnMount() {
            const selected = this.product?.selected;
            if (!!selected) {
                this.selected = Number(selected);
            }
        },

        findTypeProductAndReturnTruthlyValue() {
            const type = this.product.type;
            this.typeProduct = this.getProductTypeCodes[type];
        },

        showNotification(type = "success", title, text) {
            this.$notify({
                type,
                title,
                text,
                duration: 3000
            });
        },

        updatePriceFormat(price) {
            const result = new Intl.NumberFormat("en-US").format(price);
            return result.replaceAll(",", " ");
        },

        ecommerceAddProduct(){
            window.dataLayer.push({
                "ecommerce": {
                    "currencyCode": "UZS",
                    "add": {
                        "products": [
                            {
                                "id": this.product.id,
                                "name" : this.product.name + " " + this.product.title,
                                "price": this.product.price,
                                "brand": this.product.brand.name,
                                "category": this.product.catalog.name,
                                "quantity": 1
                            }
                        ]
                    }
                }
            });
        },
        ecommerceRemoveProduct(){
            window.dataLayer.push({
                "ecommerce": {
                    "currencyCode": "UZS",
                    "remove": {
                        "products": [
                            {
                                "id": this.product.id,
                                "name" : this.product.name + " " + this.product.title,
                                "price": this.product.price,
                                "brand": this.product.brand.name,
                                "category": this.product.catalog.name,
                                "quantity": 1
                            }
                        ]
                    }
                }
            });
        },
    },

    async mounted() {
        const isLoggedin = window.Laravel.isLoggedin;
        this.isLoggedin = isLoggedin;
        this.findTypeProductAndReturnTruthlyValue();

        if (!!isLoggedin) {
            this.updateSelectedOnMount();
        }

        if (!isLoggedin) {
            this.updateProductSelectedCountLocallyWhenUnLogin();
            this.checkForProductIsItLikedLocally();
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../../../sass/_variables.scss";
@import "../../../../sass/_mixins.scss";

.product__card {
    padding: 10px;
    width: auto;
    border: 1px solid #f2f2f2;
    box-shadow: 0px 2px 8px 1px rgba(0, 0, 0, 0.05);

    display: flex;
    flex-direction: column;
    border-radius: 10px;

    &:hover {
        box-shadow: 0px 2px 8px 1px rgba(0, 0, 0, 0.15);
    }

    .article__box {
        margin-bottom: 10px;

        .text {
            display: flex;
            justify-content: space-between;
            align-items: center;

            span {
                font-family: Acrom-Medium, sans-serif;
                font-size: 14px;
                line-height: 1.3;
                /* black_main */
                color: #808080;
            }

            .bold {
                color: #363f4d;
            }

            .svg__box {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 24px;
                height: 24px;

                button {
                    background-color: transparent;
                    border: none;
                    outline: none;
                    padding: 0;
                    margin: 0;

                    &:hover {
                        cursor: pointer;
                    }
                }
            }
        }
    }

    .img__box {
        margin-bottom: 10px;
        width: 100%;
        padding-top: 100%;
        position: relative;

        a {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;

            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }
    }

    .rate__box {
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;

        .rate__block {
            line-height: 1;
        }

        .comment__box {
            display: flex;
            align-items: center;

            .svg__box {
                margin-right: 5px;
            }

            span {
                font-family: Acrom-Medium, sans-serif;
                font-size: 12px;
                line-height: 1;
                /* grey */
                color: #808080;
            }
        }
    }

    .name__box {
        display: flex;
        line-height: 1.3;
        height: 65px;
        overflow: hidden;
        margin-bottom: 7px;

        span {
            font-family: Acrom-Medium, sans-serif;
            font-size: 15px;
            line-height: 1.5;
            /* or 22px */
            /* black_main */
            color: #363f4d;
        }
    }

    .price__box {
        height: 100px;
        overflow-y: hidden;

        .heading {
            display: flex;
            flex-direction: column;
            margin-bottom: 5px;
            line-height: 1;

            span {
                font-family: Acrom-Medium, sans-serif;
                font-size: 14px;
                /* grey_main */
                color: #7a7a7a;
                padding-bottom: 5px;
                border-bottom: 1px solid #e0e0e0;
            }

            .error {
                text-decoration: underline;
                color: #cc3a3aed;
            }
        }

        .heading_second {
            margin-bottom: 10px;
        }
        .amount {
            display: flex;
            flex-direction: column;
            line-height: 1;
            padding-bottom: 15px;
            border-bottom: 1px solid #e0e0e0;

            .new__price {
                font-family: Acrom-Bold, sans-serif;
                font-size: 18px;
                line-height: 1;
                /* identical to box height */
                /* black_main */
                color: #363f4d;

                height: 18px;
                overflow: hidden;
            }
            .new__price__kvm{
                font-family: Acrom-Medium, sans-serif;
                font-size: 12px;
                color: #7a7a7a;
                padding-top: 10px;
            }
            .old__price {
                font-family: Acrom-Medium, sans-serif;
                font-size: 13px;
                line-height: 1;
                /* identical to box height */
                /* grey */
                color: #808080;
                text-decoration: line-through;
                padding-top: 5px;
                padding-bottom: 5px;
                border-bottom: 1px solid #e0e0e0;
            }
        }
    }

    .check__out__box {
        width: 100%;

        .check__out__button {
            width: 100%;
            line-height: 1;
            display: flex;
            justify-content: flex-end;

            button {
                @include btnClassFirst;
                line-height: 1;
                outline: none;
                border: none;
                font-family: Acrom-Bold, sans-serif;
                font-size: 12px;
                line-height: 1;
                text-transform: uppercase;
                color: #ffffff;
                border-radius: 5px;

                padding: 12px 22px;

                width: 100%;

                &:hover {
                    cursor: pointer;
                }

                &:disabled:hover {
                    cursor: auto;
                }
            }
        }
    }

    .count__toggle {
        width: 100%;
        height: 36px;
        line-height: 1;
        display: flex;
        border-radius: 3px;
        border: 1px solid #e0e0e0;
        border-radius: 5px;
        margin-right: 10px;

        .count {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            input {
                font-family: Acrom-Medium, sans-serif;
                font-size: 14px;
                line-height: 1;
                /* identical to box height */
                /* grey_main */
                color: #7a7a7a;
                height: 100%;
                width: 100%;
                text-align: center;
                border: none;
                outline: none;
            }

            input[type="number"]::-webkit-inner-spin-button,
            input[type="number"]::-webkit-outer-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }

            button {
                border: none;
                outline: none;
                background-color: transparent;
                font-family: Acrom-Medium, sans-serif;
                font-size: 16px;
                font-weight: 700;
                flex-basis: 25%;

                &:hover {
                    cursor: pointer;
                }
            }

            .error {
                color: #cc3a3aed;
            }
        }
    }
}

@media only screen and (max-width: 550px) {
    .product__card {
        padding: 8px;
        width: auto;

        .article__box {
            .text {
                font-size: 12px;
            }
        }

        .rate__box {
            .rate__block {
                transform: scale(0.85);
                margin-left: -5px;
            }

            .comment__box {
                .svg__box {
                    width: 12px;
                    height: 12px;
                }

                span {
                    display: none;
                }
            }
        }

        .name__box {
            height: 50px;
            line-height: 1;
            margin-bottom: 4px;

            span {
                font-size: 13px;
                line-height: 1;
            }
        }

        .price__box {
            height: 74px;

            .heading {
                margin-bottom: 1px;

                span {
                    padding-bottom: 3px;
                }
            }

            .heading_second {
                margin-bottom: 3px;
            }

            .amount {
                .new__price {
                    font-size: 14px;
                    height: 14px;
                }

                .old__price {
                    font-size: 12px;
                    padding-top: 4px;
                    padding-bottom: 0;
                    border-bottom: none;
                }
            }
        }

        .check__out__box {
            .check__out__button {
                button {
                    font-size: 11px;
                    padding: 11px auto;
                }
            }
        }
    }
}
</style>
